export type SparkleIconProps = {
  /** Edge length in px. Default 14 — sized to sit beside 13px navbar label text. */
  size?: number;
  className?: string;
};

/**
 * A four-pointed sparkle (✦), drawn rather than typed.
 *
 * This is the AI-assistant mark. It is an inline SVG and NOT the `✦` character
 * (U+2726 BLACK FOUR POINTED STAR) on purpose: that glyph is missing from Inter,
 * so a text version renders through whatever the platform fallback happens to be
 * — a different weight and optical size on every OS, and a tofu box where no
 * fallback carries it. The path below is the same shape everywhere.
 *
 * Not from `@tabler/icons-react`: the installed version has no plain
 * `IconSparkles` (only `Icon*Spark` composites, which are other glyphs with a
 * spark attached).
 *
 * Fills with `currentColor`, so it inherits the button's colour in both themes
 * and needs no light-dark handling of its own. Decorative — every caller labels
 * the control itself, so it is `aria-hidden`.
 */
export function SparkleIcon({ size = 14, className }: SparkleIconProps ) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 1.5c.62 5.2 5.3 9.88 10.5 10.5-5.2.62-9.88 5.3-10.5 10.5-.62-5.2-5.3-9.88-10.5-10.5C6.7 11.38 11.38 6.7 12 1.5Z" />
    </svg>
  );
}

export default SparkleIcon;
